import produce from "immer";
import React, { FC } from "react";
import { useDispatch, useSelector } from "react-redux";
import { startEditElement } from "../../../../actions/elementListAction";
import { Element } from "../../../../models/elementModel";
import { TabelHeading } from "../../../../models/tabelHeading";
import { getAllElements } from "../../../../selectors/elementListSelector";
import elementService from "../../../../services/elementService";

export interface TableHeadingItemProps {
  element: Element;
  index: number;
  heading: TabelHeading;
}

const TableHeadingItem: FC<TableHeadingItemProps> = ({
  element,
  index,
  heading,
}) => {
  const dispatch = useDispatch();
  const elementState = useSelector(getAllElements);
  const removeColumn = async () => {
    let cellElementList: Element[] = [];
    const newElement = produce(element, (draft) => {
      for (let i = 0; i < draft.properties.rows.length; i++) {
        cellElementList = cellElementList.concat(
          elementState.present.filter((element) => {
            return element.cellId === draft.properties.rows[i].cells[index].id;
          })
        );
        draft.properties.rows[i].cells.splice(index, 1);
      }
      draft.properties.headings.splice(index, 1);
    });
    await elementService.deleteElements(cellElementList);
    dispatch(startEditElement(newElement));
  };
  const changeHeading = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newElement = produce(element, (draft) => {
      draft.properties.headings[index].name = e.target.value;
    });
    dispatch(startEditElement(newElement));
  };
  return (
    <div className="form-group row">
      <label htmlFor="heading" className="col-sm-4 col-form-label font-size-12">
        Heading
      </label>
      <div className="col-sm-6">
        <input
          type="text"
          className="form-control theam-textbox"
          id="heading"
          value={heading.name}
          onChange={(e) => changeHeading(e)}
        />
      </div>
      <div className="col-sm-2">
        <i
          onClick={removeColumn}
          className="fa fa-trash-o"
          aria-hidden="true"
        ></i>
      </div>
    </div>
  );
};

export default TableHeadingItem;
